import moment from 'moment';
import { getDateTimeFormat, getOrderDateFormat, getShortDateFormat } from './dateTimeFormatting';
import { IOrderListItem } from './deliveryUtil';

export function getOrderDate(createdDate: string) {
  return moment.utc(createdDate).local().format(getOrderDateFormat());
}

export function getCollectOrderDate(createdDate: string) {
  return moment.utc(createdDate).local().format(getDateTimeFormat());
}

export function getOrderFilterDate(createdDate: string) {
  if (!createdDate) {
    return null;
  }
  return moment.utc(createdDate).local().format(getShortDateFormat());
}

export function getLastUpdateDate(data: IOrderListItem) {
  if (data.LatestUpdateForArchived) {
    return getOrderDate(data.LatestUpdateForArchived);
  }

  if (data.OutForDelivery) {
    return getOrderDate(data.OutForDelivery);
  }

  return "-";
}